import React, { Fragment, useState } from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { Box, Collapse, IconButton, Table, TableBody, TableHead, Typography } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { isArrayEmpty, isArrayNotEmpty, TableButton } from "@duosoftbg/nacid-components";
import { SitemapButtonTableCell, SitemapEmptyListAlert } from "./SitemapEdit";
import {
  sitemapLinkCreationInitialValues,
  sitemapLinkCreationValuesOnEdit,
  sitemapSubGroupCreationValuesOnEdit,
} from "../../../../../init/sitemapCreationInitialValues";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import { openDeleteModal, openEditModal } from "../../../../../store/redux/slice/ComponentsControl/sitemapControl";
import { sitemapSection } from "../../../../../utils/constants";

type SitemapSubGroupRowProps = {
  subGroup: any;
};

const SitemapSubGroupRow = ({ subGroup }: SitemapSubGroupRowProps) => {
  const dispatch = useAppDispatch();

  const onClickEditSubGroupButton = (existedSubGroup) => {
    dispatch(openEditModal({ section: sitemapSection.subGroup, object: existedSubGroup }));
  };

  const onClickDeleteSubGroupButton = (id) => {
    dispatch(openDeleteModal({ section: sitemapSection.subGroup, id: id }));
  };

  const onClickCreateLinkButton = (subGroupId) => {
    dispatch(
      openEditModal({
        section: sitemapSection.link,
        object: { ...sitemapLinkCreationInitialValues, subGroupId: subGroupId },
      }),
    );
  };

  const onClickEditLinkButton = (existedLink) => {
    dispatch(
      openEditModal({
        section: sitemapSection.link,
        object: existedLink,
      }),
    );
  };

  const onClickDeleteLinkButton = (id) => {
    dispatch(openDeleteModal({ section: sitemapSection.link, id: id }));
  };

  const { t } = useTranslation();
  const [openSubGroup, setOpenSubGroup] = useState(false);
  const links = subGroup.links;
  return (
    <Fragment>
      <TableRow key={subGroup.id}>
        <TableCell align="center">
          <IconButton aria-label="expand row" size="small" onClick={() => setOpenSubGroup(!openSubGroup)}>
            {openSubGroup ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell>{subGroup.id}</TableCell>
        <TableCell>{subGroup.name}</TableCell>
        <TableCell>{subGroup.nameEn}</TableCell>
        <TableCell align="center">{subGroup.position}</TableCell>
        <SitemapButtonTableCell>
          <TableButton
            type={"edit"}
            onClick={() =>
              onClickEditSubGroupButton(
                sitemapSubGroupCreationValuesOnEdit({
                  mainGroupId: "",
                  id: subGroup.id,
                  name: subGroup.name,
                  nameEn: subGroup.nameEn,
                  position: subGroup.position,
                }),
              )
            }
          />
          <TableButton
            onClick={() => {
              onClickDeleteSubGroupButton(subGroup.id);
            }}
            type={"remove"}
          />
        </SitemapButtonTableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={openSubGroup} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                {t("l.table.head.links")}
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead style={{ background: "#dde1fb" }}>
                  <TableRow>
                    <TableCell>{t("l.table.head.id")}</TableCell>
                    <TableCell>{t("l.table.head.linkName")}</TableCell>
                    <TableCell>{t("l.table.head.linkNameEn")}</TableCell>
                    <TableCell>{t("l.table.head.link")}</TableCell>
                    <TableCell>{t("l.table.head.position")}</TableCell>
                    <TableCell align="right">
                      <TableButton type={"create"} onClick={() => onClickCreateLinkButton(subGroup.id)} />
                    </TableCell>
                  </TableRow>
                </TableHead>
                {isArrayNotEmpty(links) && (
                  <TableBody>
                    {links.map((link) => (
                      <TableRow key={link.id}>
                        <TableCell>{link.id}</TableCell>
                        <TableCell>{link.name}</TableCell>
                        <TableCell>{link.nameEn}</TableCell>
                        <TableCell>{link.link}</TableCell>
                        <TableCell>{link.position}</TableCell>
                        <SitemapButtonTableCell>
                          <TableButton
                            type={"edit"}
                            onClick={() =>
                              onClickEditLinkButton(
                                sitemapLinkCreationValuesOnEdit({
                                  subGroupId: "",
                                  id: link.id,
                                  name: link.name,
                                  nameEn: link.nameEn,
                                  position: link.position,
                                  link: link.link,
                                }),
                              )
                            }
                          />
                          <TableButton
                            onClick={() => {
                              onClickDeleteLinkButton(link.id);
                            }}
                            type={"remove"}
                          />
                        </SitemapButtonTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
              {isArrayEmpty(links) && (
                <SitemapEmptyListAlert severity="info">{t("m.empty.list")}</SitemapEmptyListAlert>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

export default SitemapSubGroupRow;
